import { Component } from 'vue-property-decorator'
import Vue from 'vue'

@Component
export default class TicketPriorities extends Vue {
  private ticketPriorities = [
    { id: 1, label: 'Basse', bgColor: '#e3e3e3', color: '#000' },
    { id: 2, label: 'Normale', bgColor: '', color: '' },
    { id: 3, label: 'Haute', bgColor: '', color: '' },
    { id: 4, label: 'Urgente', bgColor: '', color: '' }
  ]
}
